module.exports = "/_next/static/images/step3Illustratiom-17617228b8177b770550432f5b228121.svg";